import { render } from "./TetherAccount.vue?vue&type=template&id=4598e706&scoped=true&ts=true"
import script from "./TetherAccount.vue?vue&type=script&lang=ts"
export * from "./TetherAccount.vue?vue&type=script&lang=ts"

import "./TetherAccount.vue?vue&type=style&index=0&id=4598e706&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4598e706"]])

export default __exports__